import { render, staticRenderFns } from "./CustomFieldsLeadSection.vue?vue&type=template&id=0852d71a"
import script from "./CustomFieldsLeadSection.vue?vue&type=script&lang=js"
export * from "./CustomFieldsLeadSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports